import HistoryService from '../services/History.service';

class HistoriesStore {
  histories = {};

  async fetchHistories() {
    try {
      const items = await HistoryService.fetchHistories({});

      if (items.isEmpty) {
        return null;
      }

      this.histories = items.items;
    } catch (e) {
      console.error('Failed to fetch histories data');
      return null;
    }

    return this.histories;
  }
}

export default new HistoriesStore();



// WEBPACK FOOTER //
// ./src/stores/Histories.store.js